import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { INTERNATIONAL_PHONE_CODE, PHONE_LENGTH } from 'src/app/core/config'
import { APP_ROUTES } from 'src/app/core/config/routes'
import { USER_TYPES } from 'src/app/core/enums'
import { LayoutService } from 'src/app/shared/services/layout.service'
import { SharedService } from 'src/app/shared/services/shared.service'
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'app-internal-login',
  templateUrl: './internal-login.component.html',
  styleUrls: ['./internal-login.component.scss']
})
export class InternalLoginComponent implements OnInit, OnDestroy {
  // UI toggles
  isPhoneSelected = true
  isCodeSelected = false

  // form
  loginForm: FormGroup
  phoneCode = INTERNATIONAL_PHONE_CODE
  phoneLength: number = PHONE_LENGTH
  APP_ROUTES = APP_ROUTES

  // state
  componentDestroyed$ = new Subject<boolean>()
  isDemoMode: boolean

  userTypes = USER_TYPES
  selectedType: string = USER_TYPES.CONTROLLER

  constructor (
    private authService: AuthService,
    private sharedService: SharedService,
    private router: Router,
    private toastr: ToastrService,
    private layoutService: LayoutService
  ) {}

  ngOnInit (): void {
    this.initializeForm()
    this.sharedService
      .getDemoStatus()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(status => {
        this.isDemoMode = status
      })

    // default type
    this.setRegisterType(this.userTypes.CONTROLLER)
  }

  initializeForm () {
    this.loginForm = new FormGroup({})
  }

  changeDemoMode () {
    this.sharedService.changeMockMode()
  }

  // handle marketer toggle
  selectPhone () {
    this.isCodeSelected = false
    this.isPhoneSelected = true
  }

  selectCode () {
    this.isCodeSelected = true
    this.isPhoneSelected = false
  }

  onSubmit () {
    if (this.loginForm.invalid) return

    let requestData: any = { ...this.loginForm.value }

    if (this.selectedType === this.userTypes.MARKETER) {
      // Always send "pairingCode"
      if (this.isPhoneSelected) {
        requestData.pairingCode =
          this.phoneCode + this.loginForm.value.phoneNumber
      } else {
        requestData.pairingCode = this.loginForm.value.pairingCode
      }

      delete requestData.phoneNumber
    } else if (this.selectedType === this.userTypes.CONTROLLER) {
      // Keep phone + pwd
      requestData.phoneNumber =
        this.phoneCode + this.loginForm.value.phoneNumber
    }

    this.authService
      .signin(this.selectedType, requestData)
      .subscribe((response: any) => {
        if (!this.sharedService?.isMock) {
          localStorage.setItem('user', JSON.stringify(response.data.user))
          localStorage.setItem('token', response.data.token)
        }
        this.toastr.success('! تم تسجيل الدخول بنجاح')
        this.layoutService.initializeSidebarListenners()
        this.router.navigate(['/'])
      })
  }

  setRegisterType (choosedType: string) {
    this.selectedType = choosedType

    // reset dynamic controls
    ;['phoneNumber', 'pwd', 'pairingCode'].forEach(c => {
      if (this.loginForm.contains(c)) {
        this.loginForm.removeControl(c)
      }
    })

    if (this.selectedType === this.userTypes.CONTROLLER) {
      this.loginForm.addControl(
        'phoneNumber',
        new FormControl('', [
          Validators.required,
          Validators.maxLength(this.phoneLength),
          Validators.minLength(this.phoneLength)
        ])
      )
      this.loginForm.addControl(
        'pwd',
        new FormControl('', Validators.required)
      )
    } else if (this.selectedType === this.userTypes.MARKETER) {
      // pairingCode is optional if phone selected
      this.loginForm.addControl('pairingCode', new FormControl(''))
      this.loginForm.addControl('phoneNumber', new FormControl('')) // optional if code selected
      this.loginForm.addControl(
        'pwd',
        new FormControl('', Validators.required)
      )
    }
    console.log('Selected type =>', this.selectedType)
  }

  ngOnDestroy (): void {
    this.componentDestroyed$.complete()
  }
}
